
import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState, type ReactNode } from "react";
import axios from "axios";
import { Card } from "rsuite";

import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { Document, Page } from 'react-pdf';
import { usePDF } from 'react-to-pdf';
import HeaderOfPage from "../tools/headerOfPage";


export default function InvoiceDetial() {
    const { t } = useTranslation();
    const [key, setKey] = useState<any>(1);
    const [numPages, setNumPages] = useState(null);

    const statusBadge = (status: string) => {
        const config: Record<string, { text: string, bg: string, color: string }> = {
            pending: { text: 'پرداخت نشده', bg: 'bg-amber-50', color: 'text-amber-700' },
            paid: { text: 'پرداخت شده', bg: 'bg-emerald-50', color: 'text-emerald-700' },
            canceled: { text: 'کنسل', bg: 'bg-red-50', color: 'text-red-700' },
            sending: { text: 'در حال ارسال', bg: 'bg-blue-50', color: 'text-blue-700' },
            archive: { text: 'بایگانی', bg: 'bg-gray-50', color: 'text-gray-700' },
        };
        const { text, bg, color } = config[status] || { text: status, bg: 'bg-gray-100', color: 'text-gray-700' };
        return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${bg} ${color}`}>{text}</span>;
    };

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'َکاربران',
            url: '/dashboard/user'
        },
        {
            name: 'لیست فاکتور',
            url: '/dashboard/user/invoices'
        },
        {
            name: ' فاکتورها',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }



    return (
        <>
            <div className="text-left directions bg-white p-4 sm:p-6 m-4 rounded-xl shadow-sm border border-gray-100 min-h-[calc(100vh-2rem)] mb-5">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="فاکتور"></HeaderOfPage>


                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">

                    <div className="col-span-3">
                        <ListofBlog key={key}></ListofBlog>
                    </div>
                </div>
            </div>

        </>
    )
}
const getProductCode = (product: any) => product?.alt || product?.code || '—';

const getProductDurability = (product: any): string | null => {
    const features = product?.feature;
    if (!features || typeof features !== 'object') return null;

    if (features['ماندگاری']) return String(features['ماندگاری']);

    for (const [key, value] of Object.entries(features)) {
        if (key.includes('ماندگاری') && value != null && value !== '') {
            return String(value);
        }
    }
    return null;
};

const STATUS_CONFIG: Record<string, { text: string, bg: string, color: string, ring: string }> = {
    pending: { text: 'پرداخت نشده', bg: 'bg-amber-50', color: 'text-amber-700', ring: 'ring-amber-200' },
    paid: { text: 'پرداخت شده', bg: 'bg-emerald-50', color: 'text-emerald-700', ring: 'ring-emerald-200' },
    canceled: { text: 'کنسل', bg: 'bg-red-50', color: 'text-red-700', ring: 'ring-red-200' },
    sending: { text: 'در حال ارسال', bg: 'bg-blue-50', color: 'text-blue-700', ring: 'ring-blue-200' },
    archive: { text: 'بایگانی', bg: 'bg-gray-50', color: 'text-gray-700', ring: 'ring-gray-200' },
};

function StatusBadge({ status }: { status: string }) {
    const cfg = STATUS_CONFIG[status] || { text: status, bg: 'bg-gray-50', color: 'text-gray-700', ring: 'ring-gray-200' };
    return (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ${cfg.bg} ${cfg.color} ${cfg.ring}`}>
            {cfg.text}
        </span>
    );
}

function SectionCard({ title, icon, children }: { title: string, icon: ReactNode, children: ReactNode }) {
    return (
        <div className="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
            <div className="flex items-center gap-2 px-4 py-3 bg-gray-50/80 border-b border-gray-100">
                <span className="text-gray-500">{icon}</span>
                <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
            </div>
            <div className="p-4">{children}</div>
        </div>
    );
}

function InfoRow({ label, value }: { label: string, value?: ReactNode }) {
    if (value == null || value === '') return null;
    return (
        <div className="flex items-start justify-between gap-3 py-2 border-b border-gray-50 last:border-0">
            <span className="text-xs text-gray-500 shrink-0">{label}</span>
            <span className="text-sm text-gray-800 text-left font-medium">{value}</span>
        </div>
    );
}

function ListofBlog() {
    const { t } = useTranslation();
    let { Id } = useParams();

    let cookie = getCookies();
    const [invoice, setList] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const { toPDF, targetRef } = usePDF({ filename: 'invoice.pdf' });

    const getalldata = async () => {
        setLoading(true);
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/invoices/' + Id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setList(res.data.message);
        } catch (error: any) {
        } finally {
            setLoading(false);
        }
    }
    const update = async (status: any) => {

        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/invoices/' + Id,
                data: {
                    status: status
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            //let mydata = res.data;
            //  console.log(config.url + '/v1/dashboard/bloggroup')
            //  console.log(res);
            getalldata();
        } catch (error: any) {

            // error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            //  setError(error.response.data.message.errors);
        }
    }
    const deleted = async (id: any) => {

        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/menus/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    getalldata();
                } catch (error) {
                    Swal.fire(t('Can not be to deleted, this item have submenu'))
                }
            }
        });

    }
    const toJalali = (date: string) => {
        const utcDate = new Date(date);
        const localDate = utcDate.toLocaleString('fa-IR', {

            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'

        }); // Converts to local time
        return localDate;


    }
    useEffect(() => {
        getalldata();
    }, []);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-24 text-gray-500" dir="rtl">
                <div className="w-10 h-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mb-4" />
                <p className="text-sm">در حال بارگذاری فاکتور...</p>
            </div>
        );
    }

    if (!invoice) {
        return (
            <div className="text-center py-24 text-gray-500" dir="rtl">
                <p className="text-base font-medium text-gray-700 mb-2">فاکتور یافت نشد</p>
                <a href="/dashboard/user/invoices" className="text-sm text-emerald-600 hover:underline">بازگشت به لیست فاکتورها</a>
            </div>
        );
    }

    return (
        <div className="directions text-right space-y-6" dir="rtl">
            {/* Action bar */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-2">
                <div>
                    <p className="text-xs text-gray-500 mb-1">شماره فاکتور</p>
                    <p className="text-sm font-mono text-gray-700 dir-ltr text-right">{invoice.id}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                    <a
                        href="/dashboard/user/invoices"
                        className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
                        بازگشت
                    </a>
                    <button
                        type="button"
                        onClick={() => toPDF()}
                        className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>
                        چاپ PDF
                    </button>
                    <a
                        href={`/dashboard/User/invoicesprice/${invoice.id}`}
                        className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition-colors shadow-sm"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" /></svg>
                        {t('چاپ لیبل ارسال')}
                    </a>
                    <a
                        href={`/dashboard/User/invoiceslabel/${invoice.id}`}
                        className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border border-black bg-white text-black hover:bg-gray-100 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                        لیبل ساده ۱۰×۱۵
                    </a>
                </div>
            </div>

            <div ref={targetRef}>
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                    {/* Sidebar */}
                    <div className="lg:col-span-4 flex flex-col gap-4">
                        <SectionCard
                            title="خلاصه فاکتور"
                            icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 14l6-6m-5.5 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm5 5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z" /></svg>}
                        >
                            <div className="rounded-lg bg-emerald-50 border border-emerald-100 p-4 mb-4 text-center">
                                <p className="text-xs text-emerald-600 mb-1">مبلغ کل</p>
                                <p className="text-2xl font-bold text-emerald-800">
                                    {invoice.totalprice.toLocaleString('fa-IR')} <span className="text-sm font-normal">تومان</span>
                                </p>
                            </div>
                            <InfoRow label="تاریخ صدور" value={toJalali(invoice.createdAt)} />
                            <InfoRow label="نحوه پرداخت" value={invoice.paymentmode == "1" ? "پرداخت آنلاین" : "—"} />
                            <div className="pt-3 mt-1 border-t border-gray-100">
                                <div className="flex items-center justify-between gap-2 mb-3">
                                    <span className="text-xs text-gray-500">وضعیت</span>
                                    <StatusBadge status={invoice.status} />
                                </div>
                                <select
                                    className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400 transition-shadow"
                                    value={invoice.status}
                                    onChange={(e) => update(e.target.value)}
                                >
                                    <option value="pending">پرداخت نشده</option>
                                    <option value="paid">پرداخت شده</option>
                                    <option value="canceled">کنسل</option>
                                    <option value="sending">در حال ارسال</option>
                                    <option value="archive">بایگانی</option>
                                </select>
                            </div>
                        </SectionCard>

                        {invoice.address != null && (
                            <SectionCard
                                title="آدرس تحویل"
                                icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
                            >
                                <InfoRow label="استان" value={invoice.address.provinces} />
                                <InfoRow label="شهر" value={invoice.address.city} />
                                <InfoRow label="آدرس" value={invoice.address.address} />
                                <InfoRow label="تلفن" value={invoice.address.phone} />
                                <InfoRow label="کد پستی" value={invoice.address.postalcode} />
                            </SectionCard>
                        )}

                        {invoice.touser != null && (
                            <SectionCard
                                title="اطلاعات خریدار"
                                icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>}
                            >
                                <InfoRow label="نام" value={invoice.touser.name} />
                                <InfoRow label="نام خانوادگی" value={invoice.touser.lastname} />
                                <InfoRow label="کد ملی" value={invoice.touser.nationalcode} />
                                <InfoRow label="موبایل" value={invoice.touser.mobile} />
                            </SectionCard>
                        )}

                        {invoice.attached != null && (
                            <SectionCard
                                title="پیوست"
                                icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>}
                            >
                                <img src={config.url + invoice.attached} alt="پیوست فاکتور" className="w-full rounded-lg border border-gray-200 object-cover max-h-64" />
                            </SectionCard>
                        )}

                        {invoice.topayment?.length > 0 && (
                            <SectionCard
                                title="تراکنش‌های پرداخت"
                                icon={<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>}
                            >
                                <div className="space-y-3">
                                    {invoice.topayment.map((item: any, idx: number) => (
                                        <div
                                            key={idx}
                                            className={`rounded-lg p-3 border text-sm space-y-1 ${item.verify ? 'bg-emerald-50 border-emerald-100 text-emerald-800' : 'bg-red-50 border-red-100 text-red-800'}`}
                                        >
                                            <div className="font-semibold flex items-center gap-2">
                                                <span className={`w-2 h-2 rounded-full ${item.verify ? 'bg-emerald-500' : 'bg-red-500'}`} />
                                                {item.verify ? 'پرداخت موفق' : 'پرداخت ناموفق'}
                                            </div>
                                            {item.verify && item.data?.data?.ref_id && <div className="text-xs opacity-80">Ref: {item.data.data.ref_id}</div>}
                                            {item.verify && item.data?.data?.card_pan && <div className="text-xs opacity-80">کارت: {item.data.data.card_pan}</div>}
                                            <div className="text-xs opacity-70">{toJalali(item.createdAt)}</div>
                                        </div>
                                    ))}
                                </div>
                            </SectionCard>
                        )}
                    </div>

                    {/* Products */}
                    <div className="lg:col-span-8 flex flex-col gap-4">
                        <div className="flex items-center justify-between">
                            <h2 className="text-base font-bold text-gray-900">اقلام سفارش</h2>
                            <span className="text-xs text-gray-500 bg-gray-100 px-2.5 py-1 rounded-full">
                                {invoice.details?.length || 0} محصول
                            </span>
                        </div>

                        {invoice.details?.map((item: any, idx: number) => {
                            const durability = getProductDurability(item.product);
                            return (
                            <div key={idx} className="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">
                                <div className="p-4 sm:p-5 border-b border-gray-50 bg-gradient-to-l from-gray-50/80 to-white">
                                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                                        <div className="space-y-2 min-w-0">
                                            <h4 className="text-base font-bold text-gray-900 leading-snug">{item.product.name}</h4>
                                            <div className="flex flex-wrap gap-2">
                                                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-blue-50 text-blue-700 text-xs font-medium ring-1 ring-blue-100">
                                                    کد: {getProductCode(item.product)}
                                                </span>
                                                {durability && (
                                                    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-violet-50 text-violet-700 text-xs font-medium ring-1 ring-violet-100">
                                                        ماندگاری: {durability}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="shrink-0 text-left sm:text-left">
                                            <p className="text-xs text-gray-500 mb-0.5">جمع این محصول</p>
                                            <p className="text-lg font-bold text-emerald-700">
                                                {item.detail.totalprice.toLocaleString('fa-IR')} <span className="text-xs font-normal text-gray-500">تومان</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="overflow-x-auto">
                                    <table className="w-full text-sm">
                                        <thead>
                                            <tr className="bg-gray-50 text-xs text-gray-500 border-b border-gray-100">
                                                <th className="text-right font-semibold px-4 py-3" dir="rtl">شرح</th>
                                                <th className="text-center font-semibold px-3 py-3 w-20">تعداد</th>
                                                <th className="text-center font-semibold px-3 py-3 w-28">قیمت واحد</th>
                                                <th className="text-left font-semibold px-4 py-3 w-32">جمع</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.detail.item.map((row: any, rIdx: number) => (
                                                <tr key={rIdx} className="border-b border-gray-50 last:border-0 hover:bg-gray-50/50 transition-colors">
                                                    <td className="px-4 py-3 text-right" dir="rtl">
                                                        <span className="font-medium text-gray-900">{row.name}</span>
                                                        {row.color && (
                                                            <span className="block text-xs text-gray-500 mt-0.5">رنگ: {row.color}</span>
                                                        )}
                                                    </td>
                                                    <td className="px-3 py-3 text-center text-gray-700">{row.count?.toLocaleString('fa-IR')}</td>
                                                    <td className="px-3 py-3 text-center text-gray-700">{row.price?.toLocaleString('fa-IR')}</td>
                                                    <td className="px-4 py-3 text-left font-semibold text-gray-900">
                                                        {(row.price * row.count).toLocaleString('fa-IR')}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
